import { CompanyLogo } from '@/components/CompanyLogo'
import { Flex, Text } from '@chakra-ui/react'
import { OfferType } from 'BrokerTsLib/src/dtos'
import { getInsurerName } from 'BrokerTsLib/src/enums'
import { AnimatePresence } from 'framer-motion'
import { AnimatedProgressBar } from './AnimatedProgressBar'
import { MotionFlex, expandedItemVariants } from './animations'
import { getCompanyLabel } from './dataUtils'
import type { ChartDataItem } from './types'

interface ExpandedCompaniesListProps {
  companies: ChartDataItem[]
  selectedMetric: 'count' | 'totalValue'
  maxValue: number
  maxLabelLength: number
  insurers: Array<{ id: number; name: string }>
  textColor: string
  currencyCode?: string
}

export const ExpandedCompaniesList = ({
  companies,
  selectedMetric,
  maxValue,
  maxLabelLength,
  insurers,
  textColor,
  currencyCode
}: ExpandedCompaniesListProps) => (
  <AnimatePresence>
    {companies.map((company, index) => {
      const percentage = (company.value / maxValue) * 100
      const label = getCompanyLabel(company, selectedMetric, currencyCode)

      return (
        <MotionFlex
          key={`expanded-${company.insurerId}`}
          align="center"
          justify="space-between"
          gap={4}
          h='40px'
          variants={expandedItemVariants}
          custom={index}
          initial="hidden"
          animate="visible"
          exit="exit"
          position={'relative'}
          overflow="hidden"
        >
          <CompanyLogo
            insurer={insurers.find(x => x.id === company.insurerId) || {
              id: company.insurerId,
              name: company.name || getInsurerName(company.insurerId) || 'Neznámá pojišťovna'
            }}
            offerType={OfferType.Standard}
            width="56px"
            height="40px"
          />
          <Flex align="center" flex={1} gap={3}
            flexGrow={1} justifyContent="space-between">
            <AnimatedProgressBar percentage={percentage} metricKey={selectedMetric} />
            <Text
              fontSize="xs"
              color={textColor}
              fontWeight="medium"
              whiteSpace='nowrap'
              textAlign="right"
              w={`${maxLabelLength}ch`}
              zIndex={1}
            >
              {label}
            </Text>
          </Flex>
        </MotionFlex>
      )
    })}
  </AnimatePresence>
)
